{
  "en": {
    "issue_category": {
      "labels": {
        "backup_category": "Replacement category",
        "category_name": "Category name",
        "delete_category": "Delete category \"{name}\"?",
        "delete_category_disclaimer": "All aftercare items with this category will be reassigned to the category you select below.",
        "integration_warning": "An integration with the Aftercare module on your platform is active. If you want to create or edit categories, please ask us.",
        "new_category": "Category"
      }
    }
  }
}